import * as z from 'zod/v4';

import { apiErrorSchema } from '../error/entry.js';
import { marketplaceWagerDetailsResponse } from './MarketplaceWagerDetails.js';

export const marketplaceWagerDetailsTransformSchema = marketplaceWagerDetailsResponse.transform((result) => ({
  data: result,
}));

export const marketplaceWagerDetailsApiResponse = {
  parse: (data: unknown) => z.union([marketplaceWagerDetailsTransformSchema, apiErrorSchema]).parse(data),
} as const;
